define('fukit/view/block/resolve.options.view',['require','exports','module','uikit/uikit','../../helpers/extend.util','../../behavior/resolve.options.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                  = require('uikit/uikit'),
      ExtendUtil             = require('../../helpers/extend.util'),
      ResolveOptionsBehavior = require('../../behavior/resolve.options.behavior');

  var ResolveOptionsView = UIKit.ItemView.extend({
    className: 'page',

    template: function() {
      return '<ui name="rootView" />';
    },

    behaviors: {
      ResolveOptionsBehavior: {
        behaviorClass: ResolveOptionsBehavior,
      },
    },

    internalViewOptions: {
      rootView: ExtendUtil.extendOptionValueWithDefaults('root', {
        type: UIKit.ComponentsContainerView,
      }),
    },
  });

  module.exports = ResolveOptionsView;
});

